import styled from "styled-components";
import Typography from "components/_Shared/Typography";

const BoxName = styled(Typography)`
	text-align: center;
	margin: 0;
	line-height: 1.95em;
	font-size: 2em;
`;

export default BoxName;